module.exports = __webpack_public_path__ + "img/mobile/SmartButton-promo/btn-spin@2x.png?1.0.24";


//////////////////
// WEBPACK FOOTER
// ./out/img/mobile/SmartButton-promo/btn-spin@2x.png
// module id = 218
// module chunks = 0